// extracted by mini-css-extract-plugin
export default {"videoEmbed":"_2CEZU","player":"U9PJ6","thumbnail":"_0xBeT","overlay":"_9Iajq","button":"m7nW2","arrow":"mdyCU","icon":"SaiWH"};